export default function s3SafeKey(str) {
  if (!str) return "";
  return str.replace(/[+/#?\[\]%\s{}^`~<>|"\\]/g, "_");
}
